import * as React from "react"


export default function dailyVisitsColumn(label) {
    return {
		name: 'current',
		label: label,
		options: {
            filter: false,
			setCellProps: () => ({ sx: { textAlign: "center" } })
		}
	}
}